<ng-container *ngIf="isLink && !disabled else noLink">
  <a [customRouterLink]="link" class="btn-container link {{hidden ? 'hidden' : ''}} {{project}}">
    <button class="btn {{mode}}" type="button" [disabled]="disabled">
      <span *ngIf="!isLoading || showTextWhileLoading">{{ title }}</span>
      <div class="loader" *ngIf="isLoading"></div>
    </button>
  </a>
</ng-container>
<ng-template #noLink>
  <div class="btn-container {{hidden ? 'hidden' : ''}} {{project}}">
    <button class="btn {{mode}}" (click)="btnClicked($event)" type="button" [disabled]="disabled">
      <span *ngIf="!isLoading || showTextWhileLoading">{{ title }}</span>
      <div class="loader" *ngIf="isLoading"></div>
    </button>
  </div>
</ng-template>
